<template>
  <section
    class="fullscreen-section community-section"
    ref="section"
  >
    <!-- 배경 이미지 -->
    <div class="bg-images">
      <div
        class="bg-image"
        v-for="(item, index) in communities"
        :key="index"
        :class="{ active: activeCommunity === index && introComplete }"
      >
        <img :src="item.image" :alt="item.name" />
        <div class="bg-overlay"></div>
      </div>
    </div>

    <!-- 인트로 타이틀 -->
    <div class="intro-title" :class="{ collapsed: titleCollapsed }">
      <span v-for="(letter, i) in 'COMMUNITY'.split('')" :key="i" class="letter">{{ letter }}</span>
    </div>

    <!-- 메인 콘텐츠 (인트로 후 나타남) -->
    <div class="content-wrapper" :class="{ visible: introComplete }">
      <!-- 상단: 타이틀 -->
      <div class="title-area">
        <p class="sub-title">일상의 퀄리티를 높여줄</p>
        <p class="main-desc">다양한 커뮤니티 시설</p>
      </div>

      <!-- 중앙: 네모 아이콘들 (일렬) -->
      <div class="square-nav">
        <div
          class="square-item"
          v-for="(item, index) in communities"
          :key="index"
          :class="{ active: activeCommunity === index }"
          @click="setActiveCommunity(index)"
        >
          <div class="square-image">
            <img :src="item.thumb" :alt="item.name" />
          </div>
          <span class="square-label">{{ item.name }}</span>
        </div>
      </div>

      <!-- 하단: 선택된 커뮤니티 이름 -->
      <transition name="fade-up" mode="out-in">
        <div class="community-name" :key="activeCommunity">
          <h3>{{ communities[activeCommunity].name }}</h3>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CommunitySection',
  data() {
    return {
      activeCommunity: 0,
      isTransitioning: false,
      transitionTimeout: null,
      titleCollapsed: false,
      introComplete: false,
      introTimeout: null,
      communities: [
        {
          name: '실내수영장&유아풀장',
          thumb: 'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?w=400&q=80',
          image: 'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?w=1920&q=80'
        },
        {
          name: '다목적 체육관',
          thumb: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=400&q=80',
          image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1920&q=80'
        },
        {
          name: '실내 골프연습장&스크린 골프',
          thumb: 'https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=400&q=80',
          image: 'https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=1920&q=80'
        },
        {
          name: '게스트하우스',
          thumb: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400&q=80',
          image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1920&q=80'
        },
        {
          name: '대형 북카페',
          thumb: 'https://images.unsplash.com/photo-1521587760476-6c12a4b040da?w=400&q=80',
          image: 'https://images.unsplash.com/photo-1521587760476-6c12a4b040da?w=1920&q=80'
        },
        {
          name: '휘트니스&G·X룸',
          thumb: 'https://images.unsplash.com/photo-1540497077202-7c8a3999166f?w=400&q=80',
          image: 'https://images.unsplash.com/photo-1540497077202-7c8a3999166f?w=1920&q=80'
        },
        {
          name: '스터디룸',
          thumb: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&q=80',
          image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1920&q=80'
        },
        {
          name: '공유주방',
          thumb: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&q=80',
          image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=1920&q=80'
        }
      ]
    }
  },
  mounted() {
    this.startIntroAnimation()
  },
  beforeUnmount() {
    if (this.transitionTimeout) {
      clearTimeout(this.transitionTimeout)
    }
    if (this.introTimeout) {
      clearTimeout(this.introTimeout)
    }
  },
  methods: {
    startIntroAnimation() {
      // 0.5초 후 글자 모으기
      setTimeout(() => {
        this.titleCollapsed = true
      }, 500)
      // 1.5초 후 인트로 완료
      this.introTimeout = setTimeout(() => {
        this.introComplete = true
      }, 1500)
    },
    setActiveCommunity(index) {
      if (this.isTransitioning || !this.introComplete) return
      this.activeCommunity = index
    },
    handleScroll(direction) {
      // 인트로 중에는 스크롤 막기
      if (!this.introComplete) return true
      if (this.isTransitioning) return true

      if (direction > 0) {
        if (this.activeCommunity < this.communities.length - 1) {
          this.isTransitioning = true
          this.activeCommunity++
          this.transitionTimeout = setTimeout(() => {
            this.isTransitioning = false
          }, 800)
          return true
        } else {
          return false
        }
      } else {
        if (this.activeCommunity > 0) {
          this.isTransitioning = true
          this.activeCommunity--
          this.transitionTimeout = setTimeout(() => {
            this.isTransitioning = false
          }, 800)
          return true
        } else {
          return false
        }
      }
    },
    getSection() {
      return this.$refs.section
    },
    resetToFirst() {
      this.activeCommunity = 0
      // 인트로 리셋
      this.titleCollapsed = false
      this.introComplete = false
      this.startIntroAnimation()
    },
    setToLast() {
      this.activeCommunity = this.communities.length - 1
      // 인트로 스킵
      this.titleCollapsed = true
      this.introComplete = true
      this.isTransitioning = true
      setTimeout(() => {
        this.isTransitioning = false
      }, 300)
    }
  }
}
</script>

<style scoped>
.fullscreen-section {
  width: 100%;
  height: 100vh;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background: #111;
}

/* 배경 이미지 */
.bg-images {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 1s ease;
}

.bg-image.active {
  opacity: 1;
}

.bg-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.bg-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

/* 인트로 타이틀 */
.intro-title {
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  display: flex;
  justify-content: center;
  white-space: nowrap;
}

.intro-title .letter {
  font-family: 'Arial', sans-serif;
  font-size: 120px;
  font-weight: 800;
  color: transparent;
  -webkit-text-stroke: 2px rgba(255, 255, 255, 0.7);
  transition: margin 1s cubic-bezier(0.16, 1, 0.3, 1);
  margin: 0 25px;
  display: inline-block;
}

.intro-title.collapsed .letter {
  margin: 0 3px;
}

/* 콘텐츠 */
.content-wrapper {
  position: relative;
  z-index: 10;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: 60px 60px 100px;
  text-align: center;
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.content-wrapper.visible {
  opacity: 1;
  transform: translateY(0);
}

/* 타이틀 영역 */
.title-area {
  margin-bottom: 50px;
}

.sub-title {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 15px;
  letter-spacing: 3px;
}

.main-desc {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 3px;
}

/* 네모 네비게이션 (일렬) */
.square-nav {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 50px;
}

.square-item {
  cursor: pointer;
  transition: all 0.4s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.square-image {
  width: 120px;
  height: 120px;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.3);
  transition: all 0.4s ease;
  filter: grayscale(100%);
}

.square-item.active .square-image {
  width: 140px;
  height: 140px;
  border-color: var(--main-color1);
  filter: grayscale(0%);
  box-shadow: 0 0 30px rgba(200, 160, 100, 0.5);
}

.square-item:hover .square-image {
  border-color: rgba(255, 255, 255, 0.7);
  filter: grayscale(50%);
}

.square-item.active:hover .square-image {
  filter: grayscale(0%);
}

.square-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.square-label {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 1px;
  transition: color 0.3s ease;
}

.square-item.active .square-label {
  color: #fff;
  font-weight: 600;
}

/* 커뮤니티 이름 */
.community-name {
  min-height: 50px;
}

.community-name h3 {
  font-size: 28px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 5px;
  position: relative;
  display: inline-block;
}

.community-name h3::before,
.community-name h3::after {
  content: '';
  position: absolute;
  top: 50%;
  width: 50px;
  height: 1px;
  background: rgba(255, 255, 255, 0.4);
}

.community-name h3::before {
  right: calc(100% + 20px);
}

.community-name h3::after {
  left: calc(100% + 20px);
}

/* 트랜지션 */
.fade-up-enter-active {
  transition: all 0.6s ease;
}

.fade-up-leave-active {
  transition: all 0.3s ease;
}

.fade-up-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.fade-up-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* 반응형 */
@media (max-width: 1400px) {
  .intro-title .letter {
    font-size: 100px;
    margin: 0 20px;
  }
  .intro-title.collapsed .letter {
    margin: 0 2px;
  }
  .square-image {
    width: 110px;
    height: 110px;
  }
  .square-item.active .square-image {
    width: 130px;
    height: 130px;
  }
}

@media (max-width: 1200px) {
  .intro-title .letter {
    font-size: 80px;
    margin: 0 15px;
  }
  .intro-title.collapsed .letter {
    margin: 0 2px;
  }
  .main-desc {
    font-size: 20px;
  }
  .square-nav {
    gap: 15px;
  }
  .square-image {
    width: 100px;
    height: 100px;
  }
  .square-item.active .square-image {
    width: 115px;
    height: 115px;
  }
}

@media (max-width: 1024px) {
  .intro-title .letter {
    font-size: 60px;
    margin: 0 12px;
  }
  .intro-title.collapsed .letter {
    margin: 0 1px;
  }
  .main-desc {
    font-size: 18px;
  }
  .square-nav {
    gap: 12px;
  }
  .square-image {
    width: 85px;
    height: 85px;
  }
  .square-item.active .square-image {
    width: 100px;
    height: 100px;
  }
  .community-name h3 {
    font-size: 24px;
  }
}

@media (max-width: 768px) {
  .content-wrapper {
    padding: 40px 20px 80px;
  }
  .intro-title .letter {
    font-size: 42px;
    margin: 0 8px;
    -webkit-text-stroke: 1px rgba(255, 255, 255, 0.7);
  }
  .intro-title.collapsed .letter {
    margin: 0 1px;
  }
  .title-area {
    margin-bottom: 30px;
  }
  .sub-title {
    font-size: 13px;
  }
  .main-desc {
    font-size: 16px;
  }
  .square-nav {
    gap: 10px;
    flex-wrap: wrap;
    max-width: 500px;
  }
  .square-image {
    width: 65px;
    height: 65px;
    border-width: 2px;
  }
  .square-item.active .square-image {
    width: 75px;
    height: 75px;
  }
  .square-label {
    font-size: 9px;
  }
  .community-name h3 {
    font-size: 20px;
    letter-spacing: 3px;
  }
  .community-name h3::before,
  .community-name h3::after {
    width: 25px;
  }
}

@media (max-width: 480px) {
  .intro-title .letter {
    font-size: 32px;
    margin: 0 5px;
  }
  .intro-title.collapsed .letter {
    margin: 0 0px;
  }
  .square-nav {
    gap: 8px;
  }
  .square-image {
    width: 55px;
    height: 55px;
  }
  .square-item.active .square-image {
    width: 62px;
    height: 62px;
  }
  .square-label {
    font-size: 8px;
  }
  .community-name h3 {
    font-size: 16px;
  }
  .community-name h3::before,
  .community-name h3::after {
    display: none;
  }
}
</style>
